// extracted by mini-css-extract-plugin
export default {"recently_films_container":"recentlyFilms_recently_films_container__hBXcB","film_title":"recentlyFilms_film_title__r1zmd"};